"use client";
import React, { useState, useEffect } from "react";
import Select from "react-select";
import apiHandler from "../../common/api";
import { useParams, Link } from "react-router-dom";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import withReactContent from "sweetalert2-react-content";
import { useSelector } from "react-redux";
import { Trash2 } from "feather-icons-react/build/IconComponents";
import ServiceMenuModal from "../../../core/modals/applications/ServicemenuModal";

const AddMultiServices = () => {
  const user_data = useSelector((state) => state.user_data);
  const loginUserID = user_data?.id;
  const MySwal = withReactContent(Swal);
  const paramID = useParams();
  const businessID = paramID.id;

  const [rows, setRows] = useState([]);
  const [teamList, setTeamList] = useState([]);
  const [serviceTypes, setServiceTypes] = useState([]);
  const [categories, setCategories] = useState([]);
  const [durations, setDurations] = useState([]);
  const [priceTypes, setPriceTypes] = useState([]);
  const [businessUniqueName, setBusinessUniqueName] = useState("");
  const [isOpen, setIsopen] = useState(false);

  const [isProvideHomeService, setIsProvideHomeService] = useState(0);
 

  const rowCount = 10;

  const fetchAllDropdownData = async (businessId) => {
    try {
      const [teamRes, categoryRes, durationRes, priceTypeRes, serviceRes] =
        await Promise.all([
          apiHandler({
            method: "GET",
            route: `Superadmin/TeamListbybusinessId?businessId=${businessId}`,
          }),
          apiHandler({
            method: "GET",
            route: `Business/CategoryAll?businessId=${businessId}`,
          }),
          apiHandler({ method: "GET", route: "Business/ServiceDurationAll" }),
          apiHandler({ method: "GET", route: "Superadmin/priceTypeAll" }),
          apiHandler({ method: "GET", route: "Superadmin/serviceAll" }),
        ]);

      if (teamRes.ResponseCode === "SUCCESS") {
        setBusinessUniqueName(teamRes.ResponseData[0]?.businessUniqueName);
        const TeamMembers = teamRes.ResponseData.map((el) => ({
          value: el.id,
          label: el.fullName,
        }));

        const allTeamMembers = {
          value: "all",
          label: "All",
        };

        setTeamList([allTeamMembers, ...TeamMembers]);
      }

      if (categoryRes.ResponseCode === "SUCCESS") {
        const categoryOptions = categoryRes.ResponseData.map((u) => ({
          value: u.ID,
          label: u.categoryName,
        }));
        setCategories(categoryOptions);
      
      }

      if (durationRes.ResponseCode === "SUCCESS")
        setDurations(
          durationRes.ResponseData.map((u) => ({
            value: u.ID,
            label: u.Name,
          }))
        );

      if (priceTypeRes.ResponseCode === "SUCCESS")
        setPriceTypes(
          priceTypeRes.ResponseData.map((u) => ({
            value: u.ID,
            label: u.Name,
          }))
        );

      if (serviceRes.ResponseCode === "SUCCESS")
        setServiceTypes(
          serviceRes.ResponseData.map((u) => ({
            value: u.ID,
            label: u.Name,
          }))
        );
    } catch (error) {
      console.error("Dropdown load error:", error);
    }
  };

  const handleGenerateRows = () => {
    const newRows = Array.from({ length: rowCount }, (_, i) => ({
      id: `${Date.now()}-${i + 1}`,
      ServiceName: "",
      TeamPerson: [],
      BusinessID: businessID || "",
      ServiceType: null,
      ServiceCategory: null,
      MinDuration: null,
      MaxDuration: null,
      PriceType: null,
      Price: "",
      IsHomeService: 0,
    }));
    setRows(newRows);
  };

  const handleAddRow = () => {
    const newRow = {
      id: `${Date.now()}-${rows.length + 1}`,
      ServiceName: "",
      TeamPerson: [],
      BusinessID: businessID || "",
      ServiceType: null,
      ServiceCategory: null,
      MinDuration: null,
      MaxDuration: null,
      PriceType: null,
      Price: "",
      IsHomeService: 0,
    };
    setRows([...rows, newRow]);
  };

  useEffect(() => {
    if (businessID) {
      fetchAllDropdownData(businessID);
      handleGenerateRows();
    }
  }, [businessID]);

  const handleChange = (index, field, value) => {
    const updated = [...rows];

    if (field === "TeamPerson") {
      const isAllSelected = value?.some((v) => v.value === "all");

      if (isAllSelected) {
        updated[index][field] = teamList
          .filter((t) => t.value !== "all")
          .map((t) => t.value);
      } else {
        updated[index][field] = value ? value.map((v) => v.value) : [];
      }
    } else if (
      ["ServiceType", "ServiceCategory", "MinDuration", "MaxDuration", "PriceType"].includes(
        field
      )
    ) {
      updated[index][field] = value ? value.value : null;
    } else if (field === "IsHomeService") {
      updated[index][field] = value ? 1 : 0;
    } else {
      updated[index][field] = value;
    }

    setRows(updated);
  };

  const handleSubmitServices = async () => {
    try {
      const activeRows = rows
        .map((row, originalIndex) => ({ ...row, originalIndex }))
        .filter((row) => row.ServiceName?.trim());

      if (activeRows.length === 0) {
        Swal.fire({
          icon: "warning",
          title: "No data to submit!",
          text: "Please fill at least one row before submitting.",
        });
        return;
      }

      const validationErrors = [];

      activeRows.forEach((row) => {
        const missingFields = [];
        if (!row.ServiceType) missingFields.push("Service Type");
        if (!row.ServiceCategory) missingFields.push("Service Menu");
        if (!row.MinDuration) missingFields.push("Min Duration");
        if (!row.MaxDuration) missingFields.push("Max Duration");
        if (!row.PriceType) missingFields.push("Price Type");
        if (!row.Price || Number(row.Price) <= 0) missingFields.push("Price");
        if (!row.TeamPerson || row.TeamPerson.length === 0)
          missingFields.push("Team Person");

        if (missingFields.length > 0) {
          validationErrors.push(
            `Row ${row.originalIndex + 1}: <b>${missingFields.join(", ")}</b>`
          );
        }

        if (row.MinDuration && row.MaxDuration && Number(row.MinDuration) > Number(row.MaxDuration)) {
          validationErrors.push(
            `Row ${row.originalIndex + 1}: <b>Min Duration cannot be greater than Max Duration</b>`
          );
        }
      });

      if (validationErrors.length > 0) {
        Swal.fire({
          icon: "warning",
          title: "Please complete or correct the following fields:",
          html: validationErrors.join("<br/>"),
        });
        return;
      }

      const wrapperName = "MultiserviceJson";
      const filteredRows = activeRows.map((row) => ({
        ServiceName: row.ServiceName.trim(),
        TeamPerson: Array.isArray(row.TeamPerson)
          ? row.TeamPerson.map(Number)
          : row.TeamPerson
          ? String(row.TeamPerson)
              .split(",")
              .map((id) => Number(id.trim()))
          : [],
        BusinessID: row.BusinessID,
        ServiceType: row.ServiceType,
        ServiceCategory: row.ServiceCategory,
        MinDuration: row.MinDuration,
        MaxDuration: row.MaxDuration,
        PriceType: row.PriceType,
        Price: String(row.Price),
        IsHomeService: row.IsHomeService ? 1 : 0,
      }));

      const result = { [wrapperName]: filteredRows };

      const payload = {
        jsonBulkServiceInsert: JSON.stringify(result),
        loginUserID,
      };

      const response = await apiHandler({
        method: "POST",
        route: "Business/businessServiceUpsertBulk",
        payload,
        headers: { "Content-Type": "application/json" },
      });

      if (response.ResponseCode === "SUCCESS") {
        MySwal.fire({
          title: `${response?.ResponseID[0]?.InsertedCount} ${
            Number(response?.ResponseID[0]?.InsertedCount) > 1
              ? "services"
              : "service"
          } added successfully to ${businessUniqueName}!`,
          icon: "success",
        });

        handleGenerateRows();
        await fetchAllDropdownData(businessID);
      } else {
        Swal.fire({
          icon: "error",
          title: response.ResponseMessage || "Something went wrong!",
          timer: 1500,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      console.error("Error during submission:", error);
      Swal.fire({
        icon: "error",
        title: "Submission failed!",
        timer: 1500,
        showConfirmButton: false,
      });
    }
  };



  useEffect(() => {
    const getBusinessDetailById = async (bId) => {
      const response = await apiHandler({
        method: "GET",
        route: `Business/isBusinessProvideHomeService?businessId=${bId || 0}`,
      });
      if (response.ResponseCode === "SUCCESS") {
        const businessData = response.ResponseData[0][0]?.isProvideHomeService;
        setIsProvideHomeService(businessData);
      } 
    };

    getBusinessDetailById(businessID);
  }, []);

  const handleRemoveRow = (index) => {
    setRows((prev) => prev.filter((_, i) => i !== index));
  };

  return (
    <>
       {isOpen && (
            <ServiceMenuModal
              isOpen={isOpen}
              setIsOpen={setIsopen}
              businessId={businessID}
              callBack={() => fetchAllDropdownData()}
    
            />
          )}

      <div className="page-wrapper">
        <div className="content">
          <div className="p-3">
            <h3 className="mb-3">Add Services</h3>

            <div className="d-flex justify-content-between mb-2">
              <Link
                style={{
                  borderBottom: "1px solid var(--primary)",
                  color: "var(--primary)",
                }}
                onClick={() => setIsopen(true)}
                className="ms-auto form-label"
              >
                Create Category
              </Link>
            </div>

            <h3 className="text-center mb-4">{businessUniqueName}</h3>

            {rows.length > 0 && (
              <div className="table-responsive">
                <table className="table table-bordered align-middle">
                  <thead className="table-light">
                    <tr>
                      <th>Service Name</th>
                      <th>Service Type</th>
                      <th>Service Menu</th>
                      {isProvideHomeService == 1 && <th>Is Home Service</th>}
                      <th>Min Duration</th>
                      <th>Max Duration</th>
                      <th>Price Type</th>
                      <th>Price</th>
                      <th className="min-width-header">Team Person</th>
                      <th className="">Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((row, index) => (
                      <tr key={row.id}>
                        <td>
                          <input
                            type="text"
                            className="form-control"
                            value={row.ServiceName}
                            onChange={(e) =>
                              handleChange(index, "ServiceName", e.target.value)
                            }
                            placeholder="Enter service name"
                          />
                        </td>
                        <td>
                          <Select
                            options={serviceTypes}
                            value={serviceTypes.find(
                              (opt) => opt.value === row.ServiceType
                            )}
                            onChange={(v) =>
                              handleChange(index, "ServiceType", v)
                            }
                            placeholder="Select Service Type"
                          />
                        </td>
                        <td>
                          <Select
                            options={categories}
                            value={categories.find(
                              (opt) => opt.value === row.ServiceCategory
                            )}
                            onChange={(v) =>
                              handleChange(index, "ServiceCategory", v)
                            }
                            placeholder="Select Category"
                          />
                        </td>

                        {isProvideHomeService == 1 && (
                          <td className="text-center">
                            <input
                              type="checkbox"
                              checked={row.IsHomeService === 1}
                              onChange={(e) =>
                                handleChange(
                                  index,
                                  "IsHomeService",
                                  e.target.checked
                                )
                              }
                            />
                          </td>
                        )}
                        <td>
                          <Select
                            options={durations}
                            value={durations.find(
                              (opt) => opt.value === row.MinDuration
                            )}
                            onChange={(v) => handleChange(index, "MinDuration", v)}
                            placeholder="Min Duration"
                          />
                        </td>
                        <td>
                          <Select
                            options={durations}
                            value={durations.find(
                              (opt) => opt.value === row.MaxDuration
                            )}
                            onChange={(v) => handleChange(index, "MaxDuration", v)}
                            placeholder="Max Duration"
                          />
                        </td>
                        <td>
                          <Select
                            options={priceTypes}
                            value={priceTypes.find(
                              (opt) => opt.value === row.PriceType
                            )}
                            onChange={(v) =>
                              handleChange(index, "PriceType", v)
                            }
                            placeholder="Select Price Type"
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            className="form-control"
                            value={row.Price}
                            onChange={(e) =>
                              handleChange(index, "Price", e.target.value)
                            }
                            placeholder="Enter Price"
                          />
                        </td>
                        <td>
                          <Select
                            options={teamList}
                            isMulti
                            value={teamList.filter((opt) =>
                              row.TeamPerson.includes(opt.value)
                            )}
                            onChange={(v) =>
                              handleChange(index, "TeamPerson", v)
                            }
                            placeholder="Select Team Members"
                          />
                        </td>
                        <td>
                          <button
                            type="button"
                            className="btn btn-outline-primary btn-sm"
                            onClick={() => handleRemoveRow(index)}
                          >
                            <Trash2 className="custome-icon-size" />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                <div className="d-flex justify-content-between mt-3">
                  <button
                    className="btn btn-outline-primary"
                    onClick={handleAddRow}
                  >
                    Add Row
                  </button>
                  <button
                    className="btn btn-primary"
                    onClick={handleSubmitServices}
                  >
                    Submit Services
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AddMultiServices;
